import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"p-3 !h-full\">\n  <Visitors::TrialEndCard />\n</div>",{ moduleName: "garaje/pods/visitors/trial-ended/template.hbs" })